
<div class="content">
    {{message}}
</div>